module.exports = __webpack_public_path__ + "static/media/results-and-recommendations.085105cb.png";